import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import {  Router, Route,  Redirect, Switch } from 'react-router-dom';
import { history, store } from './core/stores';
import { routes } from './core/router';
import General from './wrappers/general';
import PrivateRoute from './core/router/private.route';
import { AUTH_STATUS } from './core/handlers.actions';
import './styles/main.scss';

class App extends Component {
  componentDidMount(){
    store.dispatch({type: AUTH_STATUS});
  }
  public render(){    
    return(
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Router history={history}>        
              {routes.map((route:any, key:number) => {                                                
                return (!route.isProtected) ? <General key={key}><Switch><Route key={key} component={route.component}  path={route.path} exact /></Switch></General>:
                <PrivateRoute key={key} component={route.component}  path={route.path} exact/>;                
              })}
              <Redirect from="*" to="/"/>
          </Router>
        </ConnectedRouter>
      </Provider>
    );
  }
}


ReactDOM.render(
  <App />,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
